// routes/index.js
import { Routes, Route } from "react-router-dom";
import Protected from "./protected";
import Home from "../pages/home";
import MentorList from "../pages/mentorlist";
import MeetOurMentor from "../pages/meetourmentors";
import About from "../pages/about";
import Query from "../pages/query";
import Calender from "../pages/calender";
import TermsOfService from "../pages/termconditions";
import MentorStudentList from "../pages/mentorstudent";
import AddtimeSlot from "../pages/mentortimeslot";
import PriceList from "../pages/pricelist";
import StudentProfile from "../pages/studentprofile";
import RegistrationForm from "../auth/registrationpage";
import OtpVerification from "../auth/verifyotp";
import LoginPage from "../auth/loginpage";
import ForgetPassword from "../auth/forgetpasswprdpage";
const Index = () => {
  return (
    <Routes>
      {/* ✅ Private route group */}
      <Route  element={<Protected />}>
        <Route path="/mentorlist" element={<MentorList />} />
        <Route path="bookcall/:id" element={<Calender />} />
        <Route path="/mentorlist/studentlist/:id" element={<MentorStudentList />} />\
        <Route path="/mentor/timeslot/:id" element={<AddtimeSlot />} />
        <Route path="/mentor/price/:id" element={<PriceList />} />
        <Route path="/profile/" element={<StudentProfile />} />
      </Route>
      {/* ✅ Public routes */}
      <Route path="/" element={<Home />} />
      <Route path="home" element={<Home />} />
      <Route path="mentors" element={<MeetOurMentor />} />
      <Route path="about" element={<About />} />
      <Route path="query" element={<Query />} />
      <Route path="termsandcondition" element={<TermsOfService />} />
      {/* <Route path="/profile/" element={<StudentProfile />} /> */}
      <Route path="/registration" element={<RegistrationForm />} />
      <Route path="/login" element={<LoginPage/>} />
      <Route path="/forget-password" element={<ForgetPassword/>} />
         <Route path="/otp-verify" element={<OtpVerification />} />
      <Route path="*" element={<h1>Page not found</h1>} />
      <Route path="/unauthorized" element={<>
      <h1 style={{color:"red"}}>Unauthorized Access</h1>
      <p>You do not have permission to view this page.</p>
    </>} />

    </Routes>
  );
};

export default Index;
